"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _WithdrawStatusComponent = _interopRequireDefault(require("./WithdrawStatusComponent"));
var _depositWithdrawalSelectors = require("../../../redux/selectors/depositWithdrawalSelectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var _withdrawActions = require("../../../redux/actions/withdrawActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var config = _ref.config;
  /**
   * @Todo - remove filtration
   */
  var withdrawTickets = (0, _depositWithdrawalSelectors.filteredWithdrawalsByProductSelector)(state, config);
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var decimalPlaces = (0, _productsSelectors.decimalsByProductId)(state);
  var activeRequests = state.apexCore.orderHistory.activeRequests;
  var fetching = activeRequests > 0;
  return {
    data: withdrawTickets,
    instruments: instruments,
    fetching: fetching,
    decimalPlaces: decimalPlaces,
    selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId', 0),
    OMSId: (0, _get["default"])(state, 'user.userInfo.OMSId', 1)
  };
};
var mapDispatchToProps = {
  cancelWithdrawTicket: _withdrawActions.cancelWithdrawTicket,
  getWithdrawTickets: _withdrawActions.getWithdrawTickets
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WithdrawStatusComponent["default"]);